import { Component } from '@angular/core';
import { Configuration } from '../../shared-files/configuration';

@Component({
  selector: 'app-translations-view',
  templateUrl: './translations-view.component.html',
  styleUrls: [
    './translations-view.component.css',
    '../../shared/styles/small-navigation.css']
})
export class TranslationsViewComponent {

  baseUrl: string;
  constructor(configuration: Configuration) {
    this.baseUrl = configuration.apiHost.replace('/api/', '') + '/Translations/Translations';
   }
}
